var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"mr-1",style:(`height: ${_vm.height}`),attrs:{"src":"/img/bertha/bertha-full-multicolor-LightMode.svg"}}),_c('span',{style:(`font-size: ${_vm.height}`)},[_vm._v("AI Assistant")])])
}
var staticRenderFns = []

export { render, staticRenderFns }